import React from "react";
import { exportComponent } from "../utils/exportComponentToImage";

export const QuizzFinished = ({ flowerRef, resultsSent }) => {
  return (
    <div>
      <h1 className="lastWord">
        Le questionnaire est terminé, merci pour vos réponses
      </h1>
      {resultsSent && (
        <h2 className="lastWord">
          Votre Fleur a été poussée sur votre fiche sur la cartographie de
          Fermes d’Avenir
        </h2>
      )}
      <div className="container_export">
        <button
          className="button_download"
          onClick={async () => {
            return exportComponent(flowerRef);
          }}
        >
          Télécharger ma Fleur de l’Agroécologie
        </button>
      </div>
    </div>
  );
};
